import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.mypage');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-mypage',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.mypage/view.scss */
/* src/app/page.mypage/view.scss: no such file or directory */`],
})
export class PageMypageComponent implements OnInit {
    public user: any = {name:'',email:'',role:''};
    public loading = false;
    public error = '';
    constructor(@Inject( Service) public service: Service) {}
    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow('/access');
        await this.load();
    }
    public async load() {
        if (this.loading) return;
        this.loading = true;
        this.error = '';
        try {
            await this.service.render();
            const {code,data} = await wiz.call('get', {}, {type: 'GET'});
            if (code === 200 && data) this.user = data;
            else this.error = '계정 정보를 불러오지 못했습니다. 다시 시도해 주세요.';
        } catch (error) {
            this.error = '계정 정보를 불러오는 중 연결이 원활하지 않습니다.';
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }
}

export default PageMypageComponent;